export default __webpack_public_path__ + "static/image-1-mob-e8609f4fa81e9356fc37f5675fae12dc.jpg";